
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, class_type, list_type, anonRecord_type, option_type, int32_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../../Shared/User.js";
import { Storage__get_DisplayName, Storage_$reflection } from "../../../Shared/Storage.js";
import { FormState__getValidation, ToolId, FormState__startLoading, FormState__setValidationResponse_5219762A, UnassignToolWithQuantityWithoutNotificationDto, FormState_get_empty, RequestedValue$1, UnassignToolWithQuantityWithoutNotificationDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, TokenDataDto_$reflection, ClientApiResponse$1_$reflection } from "../../../Shared/Shared.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../../Shared/File.js";
import { HookFlow_hasMandatoryUncompletedHooks, HookFlowProcedureModal, HookFlowSections, HookFlow_update, HookFlow_completedProcedureIds, HookFlow_initReturn, HookFlowState_$reflection, HookFlowMsg_$reflection } from "../../../Widgets/Procedure/Hooks.js";
import { ToolWithQuantityDetailDto_$reflection } from "../../../Shared/Tool.js";
import { ProcedureEntityReferenceDto } from "../../../Shared/Procedure.js";
import { sortBy, toArray, isEmpty, append, max, tryPick, sumBy, contains, filter, choose, tryFind, ofArray, singleton, empty, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_ofEffect, Cmd_none, Cmd_map, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../Communication.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { unwrapStorageId } from "../../../Shared/Helper.js";
import { map as map_1, unwrap, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { unassignCmd } from "../../../Requests/ToolWithQuantity.js";
import { safeHash, equals, createObj, comparePrimitives, stringHash } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_uploadImage } from "../../../Requests/Files.js";
import { Permission, Permissions_allowsInStorage } from "../../../Shared/Roles.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../UserPermissions.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { GroupedSelect, Select } from "../../../Components/Select.js";
import { List_groupBy } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { TextArea } from "../../../Components/TextArea.js";
import { NumberInput } from "../../../Components/Input.js";
import { numberInputIntMaxValue } from "../../../Common.js";
import { TextValue } from "../../../Components/Text.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../../../Widgets/Helper.js";
import { Dialog } from "../../../Components/Dialog.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetComment", "SetQuantity", "SetSelectedReceiver", "SetSelectedStorage", "UnassignedToolResponse", "OnUnassignTool", "ReceiversFetched", "StoragesFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded", "HookMsg"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.UnassignToolWithQuantityDialog.Msg", [], Msg, () => [[["Item", string_type]], [["Item", option_type(int32_type)]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", list_type(Receiver_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]], [["Item", HookFlowMsg_$reflection()]]]);
}

class State extends Record {
    constructor(Tool, UserData, Receivers, Storages, SuccessCallback, OnClose, FormState, Dto, SelectedReceiver, SelectedStorage, Quantity, IsQuantityInvalid, IsUserStockInvalid, SenderImageFiles, ImageUploading, Hooks) {
        super();
        this.Tool = Tool;
        this.UserData = UserData;
        this.Receivers = Receivers;
        this.Storages = Storages;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.Dto = Dto;
        this.SelectedReceiver = SelectedReceiver;
        this.SelectedStorage = SelectedStorage;
        this.Quantity = Quantity;
        this.IsQuantityInvalid = IsQuantityInvalid;
        this.IsUserStockInvalid = IsUserStockInvalid;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
        this.Hooks = Hooks;
    }
}

function State_$reflection() {
    return record_type("Tools.UnassignToolWithQuantityDialog.State", [], State, () => [["Tool", ToolWithQuantityDetailDto_$reflection()], ["UserData", TokenDataDto_$reflection()], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["Dto", UnassignToolWithQuantityWithoutNotificationDto_$reflection()], ["SelectedReceiver", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["Quantity", option_type(int32_type)], ["IsQuantityInvalid", bool_type], ["IsUserStockInvalid", option_type(int32_type)], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type], ["Hooks", HookFlowState_$reflection()]]);
}

const maxSenderImages = 5;

function init(tool, userData, successCallback, onClose) {
    let businessUnitId;
    const patternInput = HookFlow_initReturn(new ProcedureEntityReferenceDto(1, [tool.Id]), map((c) => parse(c.CategoryId), tool.Categories));
    return [new State(tool, userData, new RequestedValue$1(0, []), new RequestedValue$1(0, []), successCallback, onClose, FormState_get_empty(), new UnassignToolWithQuantityWithoutNotificationDto(userData.UserId, "", 0, "", empty(), undefined, undefined), undefined, undefined, undefined, false, undefined, empty(), false, patternInput[0]), Cmd_batch(ofArray([(businessUnitId = tool.BusinessUnitId, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(8, [Item_1])))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_1 = response_2.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
    })))), "/api/storages/access", (Item_2) => (new Msg(7, [Item_2])), (Item_3) => (new Msg(8, [Item_3]))), Cmd_map((Item_4) => (new Msg(11, [Item_4])), patternInput[1])]))];
}

function update(msg, state) {
    let bind$0040, file_1;
    switch (msg.tag) {
        case 0:
            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, (bind$0040 = state.Dto, new UnassignToolWithQuantityWithoutNotificationDto(bind$0040.ReceiverId, bind$0040.StorageId, bind$0040.Quantity, msg.fields[0], bind$0040.SenderImageUrls, bind$0040.CompletedProcedureIds, bind$0040.SignatureUrl)), state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 1:
            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, msg.fields[0], state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 3:
            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, msg.fields[0], state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 2:
            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, msg.fields[0], state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 4: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 5: {
            const matchValue = state.SelectedStorage;
            const matchValue_1 = state.SelectedReceiver;
            const matchValue_2 = state.Quantity;
            let matchResult, quantity_1, quantity_2, receiver, storage;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    if (matchValue_2 == null) {
                        matchResult = 2;
                    }
                    else if (matchValue_2 === 0) {
                        matchResult = 0;
                        quantity_1 = matchValue_2;
                    }
                    else {
                        matchResult = 1;
                        quantity_2 = matchValue_2;
                        receiver = matchValue_1;
                        storage = matchValue;
                    }
                }
                else {
                    matchResult = 3;
                }
            }
            else {
                matchResult = 3;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, true, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                case 1: {
                    const matchValue_4 = tryFind((ua) => (ua.ReceiverId === receiver.value.Id), state.Tool.UserAssignments);
                    if (matchValue_4 == null) {
                        return [state, Cmd_none()];
                    }
                    else {
                        const userAssignment = matchValue_4;
                        if (userAssignment.Quantity >= quantity_2) {
                            const senderImageUrls = choose((f) => {
                                if (f.tag === 1) {
                                    return f.fields[0].ImageUrl;
                                }
                                else {
                                    return undefined;
                                }
                            }, state.SenderImageFiles);
                            let dto;
                            const bind$0040_1 = state.Dto;
                            dto = (new UnassignToolWithQuantityWithoutNotificationDto(receiver.value.Id, unwrapStorageId(storage.value.Id), defaultArg(state.Quantity, 0), bind$0040_1.Comment, senderImageUrls, HookFlow_completedProcedureIds(state.Hooks), bind$0040_1.SignatureUrl));
                            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, false, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), unassignCmd(new ToolId(parse(state.Tool.Id)), dto, (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(8, [Item_3])))];
                        }
                        else {
                            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, userAssignment.Quantity, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                        }
                    }
                }
                case 2:
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, true, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 6: {
            const userIdsWithAssignment = map((u) => u.ReceiverId, state.Tool.UserAssignments);
            return [new State(state.Tool, state.UserData, new RequestedValue$1(1, [filter((u_1) => contains(u_1.Id, userIdsWithAssignment, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }), msg.fields[0])]), state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        }
        case 7:
            return [new State(state.Tool, state.UserData, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 8:
            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, false, state.Hooks), Cmd_none()];
        case 9: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y_1) => ((x_1 + y_1) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult_1, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult_1 = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, newFiles, true, state.Hooks), Cmd_uploadImage((Item_4) => (new Msg(10, [Item_4])), (Item_5) => (new Msg(8, [Item_5])), formData)];
                }
                default:
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, newFiles, state.ImageUploading, state.Hooks), Cmd_none()];
            }
        }
        case 10: {
            const response_3 = msg.fields[0];
            switch (response_3.tag) {
                case 0:
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                    })) | 0;
                    return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_3.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false, state.Hooks), Cmd_none()];
                }
            }
        }
        default: {
            const patternInput = HookFlow_update(msg.fields[0], state.Hooks);
            return [new State(state.Tool, state.UserData, state.Receivers, state.Storages, state.SuccessCallback, state.OnClose, state.FormState, state.Dto, state.SelectedReceiver, state.SelectedStorage, state.Quantity, state.IsQuantityInvalid, state.IsUserStockInvalid, state.SenderImageFiles, state.ImageUploading, patternInput[0]), Cmd_map((Item) => (new Msg(11, [Item])), patternInput[1])];
        }
    }
}

export function targetStorages(props) {
    return filter((s_1) => Permissions_allowsInStorage(props.Permissions, new Permission(7, []), props.UserData.UserId, unwrapStorageId(s_1.Id), s_1.AssignedUserIds), filter((s) => {
        const source = map((sps) => sps.StorageId, props.Tool.StockPerStorage);
        return contains(unwrapStorageId(s.Id), source, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        });
    }, props.Storages));
}

function DialogBody(props) {
    let elems_2, elems, elems_1, elems_4;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const targetStorages_1 = targetStorages({
        Permissions: usePermissions(),
        Storages: props.Storages,
        Tool: props.Tool,
        UserData: props.UserData,
    });
    const selectStorageProps = map((storage) => ({
        label: Storage__get_DisplayName(storage),
        value: storage,
    }), targetStorages_1);
    if (isEmpty(targetStorages_1)) {
        return reactElement("div", createObj(singleton((elems_2 = [reactElement("strong", createObj(singleton((elems = [t("tool.not_responsible_storage_msg")], ["children", reactApi.Children.toArray(Array.from(elems))])))), reactElement("p", createObj(singleton((elems_1 = [t("tool.not_responsible_storage_info_msg")], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_4 = toList(delay(() => append_1(singleton_1(createElement(Select, {
            ComponentState: props.ComponentState,
            IsClearable: false,
            Label: t("tool.switch_storage_target"),
            NoOptionsMessage: "",
            OnChange: props.SetSelectedStorage,
            Options: selectStorageProps,
            PlaceholderKey: "",
            TestId: "unassign-toolwithquantity-storage-target-input-test-id",
            Value: unwrap(props.SelectedStorage),
        })), delay(() => append_1(singleton_1(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: props.ComponentState,
            IsClearable: false,
            Key: "assign-tool-select",
            Label: t("tool.choose_sender"),
            NoOptionsMessage: "select.employee_no_options",
            OnChange: props.SetSelectedReceiver,
            Options: map((tupledArg) => {
                const receiverType = tupledArg[0];
                const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map((receiver_1) => {
                    const matchValue = receiver_1.LocationName;
                    if (matchValue != null) {
                        const locationName = matchValue;
                        if (equals(receiverType, new ReceiverTypeName(4, []))) {
                            return {
                                label: concat(locationName, " - ", ...receiver_1.Name),
                                value: receiver_1,
                            };
                        }
                        else {
                            return {
                                label: concat(receiver_1.Name, " - ", ...locationName),
                                value: receiver_1,
                            };
                        }
                    }
                    else {
                        return {
                            label: receiver_1.Name,
                            value: receiver_1,
                        };
                    }
                }, tupledArg[1]), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                }));
                return {
                    label: Helper_receiverTypeNameTranslation(t, receiverType),
                    options: receivers_1,
                };
            }, List_groupBy((receiver) => receiver.ReceiverType, props.Receivers, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            })),
            PlaceholderKey: "select.employee_placeholder",
            Value: unwrap(props.SelectedReceiver),
        }))), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("general.comment"),
            OnChange: props.SetComment,
            TestId: "unassign-toolwithquantity-comment-input-test-id",
            Value: props.Comment,
        })), delay(() => {
            let Label_3, Value_3, matchValue_1, arg_2;
            return append_1(singleton_1(createElement(NumberInput, (Label_3 = t("general.quantity_3"), (Value_3 = map_1((value_6) => value_6, props.Quantity), {
                ComponentState: props.ComponentState,
                Label: unwrap(Label_3),
                MaxValue: numberInputIntMaxValue,
                OnChange: (arg) => {
                    props.SetQuantity(map_1((value_7) => (~~value_7 | 0), arg));
                },
                TestId: "unassign-toolwithquantity-number-input-test-id",
                ValidationMessage: unwrap(props.IsQuantityInvalid ? t("tool.dialog_assign_quantity_empty_validation") : ((matchValue_1 = props.IsUserStockInvalid, (matchValue_1 == null) ? (props.IsQuantityInvalid ? t("tool.dialog_assign_quantity_empty_validation") : undefined) : ((arg_2 = {
                    quantity: matchValue_1,
                }, patternInput[1].t("tool.dialog_unassign_tool_validation", arg_2)))))),
                Value: unwrap(Value_3),
            })))), delay(() => {
                let elems_3;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_3 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "",
                    Text: t("assignment_notification.sender_images"),
                }), createElement(ImageUpload, {
                    ComponentState: props.ImageUploading ? "disabled" : props.ComponentState,
                    SelectedFiles: props.SenderImageFiles,
                    SetSelectedFile: (files) => {
                        props.Dispatch(new Msg(9, [files]));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append_1(singleton_1(createElement(HookFlowSections, {
                    Dispatch: (arg_3) => {
                        props.Dispatch(new Msg(11, [arg_3]));
                    },
                    FormState: props.FormState,
                    ReceiverTitleKey: "procedure.hooks.receiver_procedures_return",
                    SenderTitleKey: "procedure.hooks.sender_procedures_return",
                    State: props.Hooks,
                    TestIdPrefix: "return-twq",
                })), delay(() => {
                    const matchValue_2 = FormState__getValidation(props.FormState, t, "global");
                    if (matchValue_2 == null) {
                        return empty_1();
                    }
                    else {
                        return singleton_1(createElement(ErrorAlert, {
                            Label: matchValue_2,
                        }));
                    }
                }))));
            }));
        })))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
}

export function UnassignToolWithQuantityDialog(props) {
    let elems, Title, Label_1;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.Tool, props.UserData, props.SuccessCallback, props.OnClose);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_2.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(singleton((elems = [createElement(HookFlowProcedureModal, {
        Dispatch: (arg) => {
            dispatch(new Msg(11, [arg]));
        },
        State: state_2.Hooks,
    }), createElement(Dialog, (Title = t("tool.unassign_tool"), {
        Body: toList(delay(() => {
            const matchValue = state_2.Receivers;
            const matchValue_1 = state_2.Storages;
            let matchResult, receivers, storages;
            if (matchValue.tag === 0) {
                if (matchValue_1.tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                receivers = matchValue.fields[0];
                storages = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(createElement(DialogBody, {
                        Comment: state_2.Dto.Comment,
                        ComponentState: componentState,
                        Dispatch: dispatch,
                        FormState: state_2.FormState,
                        Hooks: state_2.Hooks,
                        ImageUploading: state_2.ImageUploading,
                        IsQuantityInvalid: state_2.IsQuantityInvalid,
                        IsUserStockInvalid: unwrap(state_2.IsUserStockInvalid),
                        Quantity: unwrap(state_2.Quantity),
                        Receivers: receivers,
                        SelectedReceiver: unwrap(state_2.SelectedReceiver),
                        SelectedStorage: unwrap(state_2.SelectedStorage),
                        SenderImageFiles: state_2.SenderImageFiles,
                        SetComment: (value_1) => {
                            dispatch(new Msg(0, [value_1]));
                        },
                        SetQuantity: (value) => {
                            dispatch(new Msg(1, [value]));
                        },
                        SetSelectedReceiver: (value_2) => {
                            dispatch(new Msg(2, [value_2]));
                        },
                        SetSelectedStorage: (value_3) => {
                            dispatch(new Msg(3, [value_3]));
                        },
                        Storages: storages,
                        Tool: state_2.Tool,
                        UserData: state_2.UserData,
                    }));
                default:
                    return singleton_1(createElement(Skeleton, {
                        Variant: "normal",
                    }));
            }
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-unassign-tool-with-quantity-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_1 = t("general.save"), {
            ComponentState: (state_2.ImageUploading ? true : HookFlow_hasMandatoryUncompletedHooks(state_2.Hooks)) ? "disabled" : componentState,
            Label: Label_1,
            OnClick: () => {
                dispatch(new Msg(5, []));
            },
            TestId: "save-unassign-tool-with-quantity-dialog-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

